<template>
  <p style="display: none"></p>
</template>
<script>
export default {
  beforeMount() {
    this.$store.dispatch('authTeacher/logout');
  },
};
</script>
